export const AFTERSALES_RULES = {
  REBOOK: 'exchange',
  UPGRADE: 'upgrade',
  CANCEL: 'cancel',
  SEATCHANGE: 'seatChange',
  NAMECHANGE: 'nameChange'
};

export const AFTERSALES_CHECKS = {
  REBOOK: 'canBeRebooked',
  UPGRADE: 'canBeUpgrade',
  CANCEL: ['canBeCancelled', 'canBeRefunded'],
  SEATCHANGE: 'canChangeSeat',
  NAMECHANGE: 'canChangeName'
};

export const CANCEL_AFTERSALES = 'CANCEL';

export const TRANSLATION_ID = 'fareConditions';
export const DATE_FORMAT = 'DD MMM YYYY';
export const TIME_FORMAT = 'HH:mm';
